import React, { useEffect, useState } from 'react';
import '../styles/GoogleRatingBadge.css';

const PLACE_QUERY = 'Easy Drop Taxi Coimbatore';
const MAPS_SEARCH_URL =
  'https://www.google.com/maps/search/?api=1&query=Easy+Drop+Taxi+Coimbatore';

const fetchPlaceRating = (onResult) => {
  if (!window.google?.maps?.places) return false;

  const holder = document.createElement('div');
  const service = new window.google.maps.places.PlacesService(holder);

  service.findPlaceFromQuery(
    {
      query: PLACE_QUERY,
      fields: ['place_id', 'rating', 'user_ratings_total'],
    },
    (results, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !results?.[0]) {
        return;
      }

      const match = results[0];
      service.getDetails(
        {
          placeId: match.place_id,
          fields: ['rating', 'user_ratings_total', 'url', 'name'],
        },
        (details, detailStatus) => {
          const place =
            detailStatus === window.google.maps.places.PlacesServiceStatus.OK && details
              ? details
              : match;
          if (!place.rating) return;
          onResult({
            rating: place.rating,
            count: place.user_ratings_total || 0,
            url: place.url || MAPS_SEARCH_URL,
          });
        }
      );
    }
  );

  return true;
};

const RatingStars = ({ rating }) => {
  const value = Math.max(0, Math.min(5, Number(rating) || 0));

  return (
    <span className="header-google-stars" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((index) => {
        const fill = Math.max(0, Math.min(1, value - index)) * 100;
        return (
          <span className="header-google-star" key={index}>
            <span className="header-google-star-base">★</span>
            <span className="header-google-star-fill" style={{ width: `${fill}%` }}>
              ★
            </span>
          </span>
        );
      })}
    </span>
  );
};

const GoogleRatingBadge = () => {
  const [review, setReview] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = () =>
      fetchPlaceRating((next) => {
        if (!cancelled) setReview(next);
      });

    if (!load() && !window.googleMapsReady) {
      window.addEventListener('google-maps-ready', load);
      return () => {
        cancelled = true;
        window.removeEventListener('google-maps-ready', load);
      };
    }

    return () => {
      cancelled = true;
    };
  }, []);

  const href = review?.url || MAPS_SEARCH_URL;
  const score = review?.rating ? review.rating.toFixed(1) : null;
  const count = review?.count || 0;

  return (
    <a
      className="header-google-rating"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={
        score
          ? `Google rating ${score} out of 5${count ? ` from ${count} reviews` : ''}`
          : 'Easy Drop Taxi Google Rating'
      }
    >
      {score && <RatingStars rating={review.rating} />}
      {score && (
        <span className="header-google-score">
          {score} / 5
        </span>
      )}
      <span className="header-google-label">Google Rating</span>
      {count > 0 && (
        <span className="header-google-count">
          {count.toLocaleString()} Google Reviews
        </span>
      )}
    </a>
  );
};

export default GoogleRatingBadge;
